import React from "react";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { withStyles, styled } from "@material-ui/core/styles";

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: "#fff",
  backgroundColor: "#7500c0",
}));

const ItemData = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: "black",
  backgroundColor: "RGB(238,238,238)",
}));

export default function ComingSoonAccordion() {
  return (
    <>
      <Accordion square>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1d-content"
          id="panel1d-header"
        >
          <h3>Coming Soon</h3>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={3}>
              {/* <Grid item xs>
                    <Item>SAP</Item>
                    <ItemData>
                      <div id="divMenu">
                        <ul styles={{ marginLeft: "15px" }} className="itmsDatalst">                        
                          <li><a >SAP Commissions</a></li>
                          <li><a >SAP Environment, Health & Safety</a></li>                                               
                        </ul>
                      </div>
                    </ItemData>
                  </Grid>   */}
              {/* <Grid item xs>
                    <Item>Cloud and Cloud Native</Item>
                    <ItemData>
                      <div id="divMenu">
                        <ul styles={{ marginLeft: "15px" }} className="itmsDatalst">
                          <li><a>Cloud – GCP</a></li>
                          <li><a>Talend Data Integration</a></li>
                          <li><a>DW ETL Testing</a></li>
                          <li><a>PySpark</a></li>
                          <li><a>Cloud Data Engineer - AWS</a></li>
                          <li><a>Cloud Data Engineer - GCP</a></li>
                          <li><a>Big Data and Hadoop</a></li>
                          <li><a>Data Visualization with Tableau</a></li>
                          <li><a>Data Visualization with Power BI</a></li>
                          <li><a>Data Warehousing on Cloud - Snowflake</a></li>
                        </ul>
                      </div>
                    </ItemData>
                  </Grid> */}
              {/*<Grid item xs>
                    <Item>Adobe</Item>
                    <ItemData>
                      <div id="divMenu">
                        <ul styles={{ marginLeft: "15px" }} className="itmsDatalst"> 
                          <li><a>Adobe Marketo</a></li>*/}
              {/* <li><a>AEM Sites</a></li> */}
              {/*</ul>
                      </div>
                    </ItemData>
                  </Grid>        /*    }  
                  <Grid item xs>
                    <Item>SAP</Item>
                    <ItemData>
                      <div id="divMenu">
                        <ul styles={{ marginLeft: "15px" }} className="itmsDatalst"> 
                          <li><a>SAP Transportation Management ( TM ) 
</a></li>
                        
                         </ul>
                      </div>
                    </ItemData>
                  </Grid>                
                  <Grid item xs>
                    <Item>Microsoft</Item>
                    <ItemData>
                      <div id="divMenu">
                        <ul styles={{ marginLeft: "15px" }} className="itmsDatalst">              
                          <li><a>Microsoft User Interface Design </a></li>
                        </ul>
                      </div>
                    </ItemData>
                  </Grid>
                   {/* <Grid item xs>
                    <Item>Industry and Functions</Item>
                    <ItemData>
                      <div id="divMenu">
                        <ul styles={{ marginLeft: "15px" }} className="itmsDatalst">
                          <li><a>INFOR Technical</a></li>                       
                        </ul>
                      </div>
                    </ItemData>
                  </Grid>   */}
              <Grid item xs>
                <Item>SAP</Item>
                <ItemData>
                  <div id="divMenu">
                    <ul styles={{ marginLeft: "15px" }} className="itmsDatalst">
                      <li>
                        <a>SAP Transportation Management ( TM ) </a>
                      </li>
                    </ul>
                  </div>
                </ItemData>
              </Grid>
              <Grid item xs>
                <Item>Microsoft</Item>
                <ItemData>
                  <div id="divMenu">
                    <ul styles={{ marginLeft: "15px" }} className="itmsDatalst">
                      <li>
                        <a>Microsoft User Interface Design </a>
                      </li>
                    </ul>
                  </div>
                </ItemData>
              </Grid>

              <Grid item xs>
                <Item>IX Custom Engineering</Item>
                <ItemData>
                  <div id="divMenu">
                    <ul styles={{ marginLeft: "15px" }} className="itmsDatalst">
                      <li>
                        <a>IX_PLM WindChill</a>
                      </li>
                      {/* <li><a>IX_SDV_Onboards</a></li>
                          <li><a>IX_Capital and Infrastructure Projects</a></li> */}
                    </ul>
                  </div>
                </ItemData>
              </Grid>
              {/*  <Grid item xs>
                    <Item>Others</Item>
                    <ItemData>
                      <div id="divMenu">
                        <ul styles={{ marginLeft: "15px" }} className="itmsDatalst">
                          <li><a>Electronic Medical Record</a></li>                         
                        </ul>
                      </div>
                    </ItemData>
                  </Grid> */}
            </Grid>
          </Box>
        </AccordionDetails>
      </Accordion>
    </>
  );
}
